import InfoTooltip from 'components/features/InfoTooltip';
import Typography from 'components/generics/texts/Typography';
import React from 'react';
import { DebtType } from 'types/debt-types';
import { parseMoney } from 'utils/money_utils';
import classes from './index.module.scss';

const UtilizationDetails = ({ debt }: { debt: DebtType }) => {
  const shareBookValue = debt.shareBookValue;
  const investorsCount = debt.investorsCount;

  const items = [
    { title: 'Investors', value: investorsCount },
    {
      title: (
        <Typography className={classes.shareBookTitle}>
          Share book value{' '}
          <InfoTooltip
            className={classes.toolTipIcon}
            textClassName={classes.toolTipText}
            id={'share-book-value'}
            tooltipText={`Share book value is a calculation that estimates the value of a single
             share at a given point. Investors use it as a reference to evaluate
             their investment's performance and potential returns if they were
             to sell their shares. However, it's important to note that the
             share book value is an estimate, and the actual value may differ
             due to market conditions, liquidity, and other factors.`}
          />
        </Typography>
      ),
      value: parseMoney(shareBookValue),
    },
  ];
  return (
    <div className={classes.container}>
      {items.map(({ title, value }, index) => (
        <div
          key={index}
          className={classes.box}
        >
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={classes.subtitle}>{value}</Typography>
        </div>
      ))}
    </div>
  );
};

export default UtilizationDetails;
